module.exports = __webpack_public_path__ + "static/media/tree.23393d2c.svg";